import { getters } from "./getters";
import { actions } from "./actions";
import { mutations } from "./mutations";

// initial state
const state = {
  valuesAddedToChart: false,
  updatedChartValues: null,
  periodic: null,
  ///// record viewer ////
  uneditedCurrentRecord: {},
  editMode: false,
  showUnsavedChangesIntercept: false,
  navigatingtotab: {},
  ////////////////////////
  names: [],
  // holds records of the current collection
  records: [],
  //holds previously selected records
  // UPDATE: only allow one record to be opened at a time.(and close all the other tabs)
  selectedRecords: [],
  currentlySelectedRecord: {},
  currentlySelectedRecordIndex: 0,
  ///tabs///
  tabs: [],
  currentlySelectedTab: {},
  currentlySelectedTabType: "",
  activeTabIndex: 0,
  conditionallyHiddenRecordItemIds: [],
  currentRecordDateTimeStamp: "",
  nodeMap: {
    obj: {},
    root_id: null
  },
  /////UserNotifications//////
  UserRecordNotifications: [],
  // chartDataList: [],
  // categoryIdList: [],
  // categoryData: [],
  // templates: [],
  // categories: [],
  encounters: [],
  // Groups. An object of objects of arrays of group names with nodes that belong to that group
  // The key is the full record _id. This returns the specific object for that record
  groups: {},
  // Analysis. An object of objects of arrays of analysis group names with nodes that belong to that analysis group
  // The key is the full record _id. This returns the specific object for that record
  analysis: {},
  // Events. An object of objects of arrays of Events group names with nodes that belong to that Events group
  // The key is the full record _id. This returns the specific object for that record
  // This cannot be named `events` since that wasn't reactive. Who knew?
  eventz: {},
  // Scores. An object with node_ids and numeric scores.
  scores: {},
  //////ACCOUNTS
  currentlySelectedAccount: null
};

export default {
  state,
  getters,
  actions,
  mutations
};
